import React, { createContext, useContext, useState, useEffect } from 'react';
import { TESTIMONIALS as INITIAL_TESTIMONIALS, PODCASTS as INITIAL_PODCASTS, BLOG_POSTS as INITIAL_BLOG_POSTS, BUZZSPROUT_EPISODES as INITIAL_PODCAST_EPISODER, FYRAFTEN_OG_SJAELEFRED_VIDEOS as INITIAL_FYRAFTEN_VIDEOS } from '../data';

const CMS_BASE_URL = 'https://api.dev.auxo.dk/public/v2/content';

export const YOUTUBE_EPISODE_LINKS = {
  "19908368": "https://youtu.be/oQs6F6Q45To?si=aPlPcf4uf6p22r-V",
  "19874213": "https://www.youtube.com/watch?v=S3XEuZk3l4M",
  "19815029": "https://www.youtube.com/watch?v=hPvC9a0KKd4",
  "19801801": "https://www.youtube.com/watch?v=4Y2exm1jQ_U",
  "19741233": "https://www.youtube.com/watch?v=Ume2-lZXNZ8",
  "19699989": "https://www.youtube.com/watch?v=lpnvuWABq2U",
  "19616142": "https://www.youtube.com/watch?v=0JVIc3m9BHw",
  "19615375": "https://www.youtube.com/watch?v=s-6dXqyukv0"
};

export const BUZZSPROUT_SLUGS = {
  "19908368": "19908368-lars-muhl-om-mennesket-livet-og-det-guddommelige",
  "19874213": "19874213-anne-skare-om-spiritualitet-og-nar-udvikling-gor-ondt",
  "19815029": "19815029-anne-skare-nielsen-om-spiritualitet-og-den-nye-tids-powerkvinde",
  "19801801": "19801801-freyiia-milleh-om-tidens-rystelser-og-den-feminine-kraft-der-rejser-sig-nu",
  "19744181": "19744181-montserrat-del-2-guddommelige-mirakler-pa-det-hellige-bjerg",
  "19741233": "19741233-lukas-trolle-om-astrologien-verden-og-vejen-ind-i-hjertet",
  "19740895": "19740895-montserrat-da-mit-hjerte-blev-sprunget-abent",
  "19699989": "19699989-min-opvagning-og-forste-clairvoyance",
  "19678343": "19678343-louise-overvandt-kraeften-med-holistisk-tilgang",
  "19616142": "19616142-2-del-af-intuition-med-helle-brinch",
  "19615375": "19615375-intuition-med-helle-brinch",
  "19455031": "19455031-pa-sjaelerejse-med-min-mand-saeson-2",
  "18583523": "18583523-kathiuska-suenson-om-born-og-unges-mistrivsel",
  "18149327": "18149327-5-dimension-med-kathuiska-suensen",
  "18072159": "18072159-mistrivsel-hos-born-set-med-kvantefysiske-ojne-henning-jensen",
  "17951286": "17951286-sjaels-astrologi-kend-dit-lysarbejde",
  "17909290": "17909290-bevidsthed-med-helle-brinch",
  "17754325": "17754325-fra-frygt-til-faellesskab-med-anne-skare-nielsen",
  "17748252": "17748252-henning-jensen-derfor-skaber-du-dit-eget-liv-kvantefysik-i-praksis",
  "17932290": "17932290-teresa-thaning-vejen-til-indre-og-ydre-fred"
};

export const resolveBuzzsproutEpisode = (title = '', rawLink = '', rawId = '') => {
  if (rawId && BUZZSPROUT_SLUGS[rawId]) {
    const slug = BUZZSPROUT_SLUGS[rawId];
    return {
      episodeId: rawId,
      slug,
      link: `https://www.buzzsprout.com/2530331/episodes/${slug}`,
      audioUrl: `https://www.buzzsprout.com/2530331/episodes/${slug}.mp3`,
      youtubeLink: YOUTUBE_EPISODE_LINKS[rawId] || ''
    };
  }
  const idMatch = rawLink?.match(/\/episodes\/(\d+)/);
  if (idMatch && BUZZSPROUT_SLUGS[idMatch[1]]) {
    const slug = BUZZSPROUT_SLUGS[idMatch[1]];
    return {
      episodeId: idMatch[1],
      slug,
      link: `https://www.buzzsprout.com/2530331/episodes/${slug}`,
      audioUrl: `https://www.buzzsprout.com/2530331/episodes/${slug}.mp3`,
      youtubeLink: YOUTUBE_EPISODE_LINKS[idMatch[1]] || ''
    };
  }

  const t = (title || '').toLowerCase().trim();
  let foundId = '';
  if (t.includes('lars muhl') || t.includes('19908368')) foundId = '19908368';
  else if (t.includes('udvikling gør ondt') || t.includes('udvikling gor ondt') || (t.includes('anne skare') && (t.includes('ondt') || t.includes('spørgsmål') || t.includes('sporgsmal')))) foundId = '19874213';
  else if (t.includes('powerkvinde') || (t.includes('anne skare') && (t.includes('power') || t.includes('nye tids')))) foundId = '19815029';
  else if (t.includes('freyiia') || t.includes('tidens rystelser') || t.includes('feminine kraft')) foundId = '19801801';
  else if (t.includes('montserrat del 2') || t.includes('mirakler')) foundId = '19744181';
  else if (t.includes('lukas trolle')) foundId = '19741233';
  else if (t.includes('montserrat: da mit hjerte') || (t.includes('montserrat') && !t.includes('del 2'))) foundId = '19740895';
  else if (t.includes('opvågning') || t.includes('opvagning') || t.includes('clairvoyance')) foundId = '19699989';
  else if (t.includes('louise') || t.includes('kræften') || t.includes('kraeften')) foundId = '19678343';
  else if (t.includes('2. del af intuition')) foundId = '19616142';
  else if (t.includes('intuition med helle') || t.includes('intuition')) foundId = '19615375';
  else if (t.includes('sjælerejse') || t.includes('sjaelerejse') || t.includes('mand')) foundId = '19455031';
  else if (t.includes('kathiuska') && (t.includes('mistrivsel') || t.includes('unge'))) foundId = '18583523';
  else if (t.includes('dimension')) foundId = '18149327';
  else if (t.includes('mistrivsel hos børn') || (t.includes('mistrivsel') && t.includes('henning'))) foundId = '18072159';
  else if (t.includes('sjæls astrologi') || t.includes('sjaels astrologi') || t.includes('lysarbejde')) foundId = '17951286';
  else if (t.includes('bevidsthed')) foundId = '17909290';
  else if (t.includes('fra frygt til fællesskab') || t.includes('fra frygt til faellesskab') || (t.includes('anne skare') && (t.includes('frygt') || t.includes('fællesskab') || t.includes('faellesskab')))) foundId = '17754325';
  else if (t.includes('derfor skaber du dit eget liv') || (t.includes('kvantefysik') && t.includes('henning'))) foundId = '17748252';
  else if (t.includes('teresa thaning') || t.includes('fred')) foundId = '17932290';

  if (foundId && BUZZSPROUT_SLUGS[foundId]) {
    const slug = BUZZSPROUT_SLUGS[foundId];
    return {
      episodeId: foundId,
      slug,
      link: `https://www.buzzsprout.com/2530331/episodes/${slug}`,
      audioUrl: `https://www.buzzsprout.com/2530331/episodes/${slug}.mp3`,
      youtubeLink: YOUTUBE_EPISODE_LINKS[foundId] || ''
    };
  }

  return null;
};

const CmsContext = createContext(null);

export const CmsProvider = ({ children }) => {
  const [testimonials, setTestimonials] = useState(INITIAL_TESTIMONIALS);
  const [podcasts, setPodcasts] = useState(INITIAL_PODCASTS);
  const [podcastEpisoder, setPodcastEpisoder] = useState(INITIAL_PODCAST_EPISODER);
  const [fyraftenVideos, setFyraftenVideos] = useState(INITIAL_FYRAFTEN_VIDEOS);
  const [blogPosts, setBlogPosts] = useState(INITIAL_BLOG_POSTS);
  const [retreats, setRetreats] = useState([]);
  const [courses, setCourses] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [virksomheder, setVirksomheder] = useState([]);
  const [omMette, setOmMette] = useState(null);
  const [forside, setForside] = useState(null);
  const [workshopFrisaetDig, setWorkshopFrisaetDig] = useState(null);
  const [kvindeKendDinPower, setKvindeKendDinPower] = useState(null);
  const [retreatMontserrat, setRetreatMontserrat] = useState(null);
  const [retreatCostaDelSol, setRetreatCostaDelSol] = useState(null);
  const [retreatThailand, setRetreatThailand] = useState(null);
  const [virksomhedspraktik, setVirksomhedspraktik] = useState(null);
  const [frisaetDig, setFrisaetDig] = useState(null);
  const [frisaetDigModuler, setFrisaetDigModuler] = useState([]);
  const [gratisWorkshop, setGratisWorkshop] = useState(null);
  const [gratisMeditationer, setGratisMeditationer] = useState(null);
  const [meditationer, setMeditationer] = useState([]);
  const [navigation, setNavigation] = useState([]);
  const [foredrag, setForedrag] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchAllCmsData = async () => {
      try {
        // Fetch all collections in parallel
        const [
          udtalelserRes,
          podcastsRes,
          artiklerRes,
          retreatsRes,
          forloebRes,
          sessionerRes,
          virksomhederRes,
          omMetteRes,
          forsideRes,
          workshopFrisaetDigRes,
          kvindeKendDinPowerRes,
          retreatMontserratRes,
          retreatCostaDelSolRes,
          retreatThailandRes,
          virksomhedspraktikRes,
          podcastEpisoderRes,
          navigationRes,
          frisaetDigRes,
          frisaetDigModulerRes,
          gratisWorkshopRes,
          gratisMeditationerRes,
          meditationerRes,
          foredragRes
        ] = await Promise.allSettled([
          fetch(`${CMS_BASE_URL}/udtalelser?limit=100`),
          fetch(`${CMS_BASE_URL}/podcasts?limit=50`),
          fetch(`${CMS_BASE_URL}/artikler?limit=50`),
          fetch(`${CMS_BASE_URL}/retreats?limit=50`),
          fetch(`${CMS_BASE_URL}/forloeb_og_workshops?limit=50`),
          fetch(`${CMS_BASE_URL}/sessioner?limit=50`),
          fetch(`${CMS_BASE_URL}/virksomheder?limit=50`),
          fetch(`${CMS_BASE_URL}/om_mette?limit=10`),
          fetch(`${CMS_BASE_URL}/forside?limit=10`),
          fetch(`${CMS_BASE_URL}/workshop_frisaet_dig?limit=10`),
          fetch(`${CMS_BASE_URL}/kvinde_kend_din_power?limit=10`),
          fetch(`${CMS_BASE_URL}/retreat_montserrat?limit=10`),
          fetch(`${CMS_BASE_URL}/retreat_costa_del_sol?limit=10`),
          fetch(`${CMS_BASE_URL}/retreat_thailand?limit=10`),
          fetch(`${CMS_BASE_URL}/virksomhedspraktik?limit=10`),
          fetch(`${CMS_BASE_URL}/podcast_episoder?limit=100`),
          fetch(`${CMS_BASE_URL}/navigation?limit=100`),
          fetch(`${CMS_BASE_URL}/frisaet_dig?limit=10`),
          fetch(`${CMS_BASE_URL}/frisaet_dig_moduler?limit=50&sort=nummer&order=asc`),
          fetch(`${CMS_BASE_URL}/gratis_workshop?limit=10`),
          fetch(`${CMS_BASE_URL}/gratis_meditationer?limit=10`),
          fetch(`${CMS_BASE_URL}/meditationer?limit=50&sort=nummer&order=asc`),
          fetch(`${CMS_BASE_URL}/foredrag?limit=10`)
        ]);

        if (!isMounted) return;

        // Process udtalelser (Testimonials)
        if (udtalelserRes.status === 'fulfilled' && udtalelserRes.value.ok) {
          const json = await udtalelserRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            const mapped = json.items.map((item) => {
              const plainText = item.udtalelse
                ? item.udtalelse
                    .replace(/<\/p>|<br\s*\/?>/gi, '\n')
                    .replace(/<p[^>]*>/gi, '')
                    .replace(/<(?!\/?u\b)[^>]+>/gi, '')
                    .replace(/\n\n+/g, '\n\n')
                    .trim()
                : '';
              return {
                id: item.id,
                name: item.navn || '',
                title: item.titel || '',
                highlight: item.fremhaevet_citat || (plainText ? plainText.slice(0, 150) + '...' : ''),
                text: plainText,
                html: item.udtalelse || '',
                category: item.terms?.kategori?.[0] || 'sessioner',
                categories: item.terms?.kategori || [item.terms?.kategori?.[0] || 'sessioner']
              };
            });
            // Ensure Marianne Helleskov's "En dags kursus" testimonial is at the very start per customer instruction ("tilføj til start til udtalelser")
            // and ensure key testimonials (Else Støchkel, Maria Frandsen, Jane Cedersted, Mie Jessen) are prominently placed
            const elseIdx = mapped.findIndex((item) => item.name === 'Else Støchkel');
            if (elseIdx >= 0) {
              const [elseItem] = mapped.splice(elseIdx, 1);
              elseItem.category = 'forloeb';
              if (!elseItem.categories || !elseItem.categories.includes('forloeb')) {
                elseItem.categories = ['forloeb', ...(elseItem.categories || [])];
              }
              mapped.unshift(elseItem);
            }

            const marianneHeldagIdx = mapped.findIndex(
              (item) => item.name === 'Marianne Helleskov' && (item.title?.toLowerCase().includes('kursus') || item.text?.toLowerCase().includes('frisæt dig'))
            );
            if (marianneHeldagIdx > 0) {
              const [marianneItem] = mapped.splice(marianneHeldagIdx, 1);
              mapped.unshift(marianneItem);
            }
            setTestimonials(mapped);
          }
        }

        // Process podcasts
        if (podcastsRes.status === 'fulfilled' && podcastsRes.value.ok) {
          const json = await podcastsRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            const mapped = json.items.map((item) => ({
              id: item.id,
              title: item.titel?.da || (typeof item.titel === 'string' ? item.titel : ''),
              titleEn: item.titel?.en || item.titel?.da || '',
              description: item.beskrivelse?.da || (typeof item.beskrivelse === 'string' ? item.beskrivelse : ''),
              descriptionEn: item.beskrivelse?.en || item.beskrivelse?.da || '',
              image: item.billede?.[0] || '/kundebilleder/podcast1.png',
              link: item.spotify_link || 'https://open.spotify.com',
              buzzsproutLink: item.buzzsprout_link || 'https://www.buzzsprout.com/2530331/episodes'
            }));
            setPodcasts(mapped);
          }
        }

        // Process podcast_episoder (Buzzsprout episodes)
        if (podcastEpisoderRes.status === 'fulfilled' && podcastEpisoderRes.value.ok) {
          const json = await podcastEpisoderRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            const mapped = json.items.map((item) => {
              const itemTitleDa = item.titel?.da || (typeof item.titel === 'string' ? item.titel : '');
              const matchedLocal = INITIAL_PODCAST_EPISODER.find(
                (loc) => loc.title.toLowerCase().trim() === itemTitleDa.toLowerCase().trim() ||
                         loc.id === item.id ||
                         (loc.title && itemTitleDa && (loc.title.includes(itemTitleDa) || itemTitleDa.includes(loc.title)))
              );

              const resolved = resolveBuzzsproutEpisode(
                itemTitleDa || matchedLocal?.title,
                (item.buzzsprout_link && item.buzzsprout_link !== 'https://www.buzzsprout.com/2530331/episodes') ? item.buzzsprout_link : matchedLocal?.link,
                item.episode_id || matchedLocal?.episodeId
              );

              const episodeId = resolved?.episodeId || item.episode_id || matchedLocal?.episodeId || '';
              const link = resolved?.link || (item.buzzsprout_link && item.buzzsprout_link !== 'https://www.buzzsprout.com/2530331/episodes' ? item.buzzsprout_link : matchedLocal?.link) || '';
              const audioUrl = resolved?.audioUrl || (episodeId ? `https://www.buzzsprout.com/2530331/episodes/${episodeId}.mp3` : '');
              const youtubeLink = item.youtube_link || item.youtubeLink || resolved?.youtubeLink || matchedLocal?.youtubeLink || YOUTUBE_EPISODE_LINKS[episodeId] || '';

              return {
                id: item.id,
                episodeId,
                title: itemTitleDa || matchedLocal?.title || '',
                titleEn: item.titel?.en || item.titel?.da || matchedLocal?.titleEn || '',
                description: item.beskrivelse?.da || (typeof item.beskrivelse === 'string' ? item.beskrivelse : '') || matchedLocal?.description || '',
                descriptionEn: item.beskrivelse?.en || item.beskrivelse?.da || matchedLocal?.descriptionEn || '',
                duration: item.varighed || matchedLocal?.duration || '',
                date: item.udgivelsesdato?.da || (typeof item.udgivelsesdato === 'string' ? item.udgivelsesdato : '') || matchedLocal?.date || '',
                dateEn: item.udgivelsesdato?.en || item.udgivelsesdato?.da || matchedLocal?.dateEn || '',
                season: item.saeson_info?.da || (typeof item.saeson_info === 'string' ? item.saeson_info : '') || matchedLocal?.season || '',
                seasonEn: item.saeson_info?.en || item.saeson_info?.da || matchedLocal?.seasonEn || '',
                image: item.billede?.[0] || matchedLocal?.image || 'https://assets.auxodev.dk/assets/e64caba9-58c8-4d09-993b-45c3c9f29d0e/ac212aed-ef99-4528-874a-da92a2da1807.jpeg',
                link,
                audioUrl,
                youtubeLink,
                spotifyLink: item.spotify_link || matchedLocal?.spotifyLink || (episodeId === '19908368' ? 'https://open.spotify.com/episode/3gpA8tDKGEjRLyQDCzZzWA?si=659be4df2af74954' : '')
              };
            });
            mapped.sort((a, b) => {
              const idxA = INITIAL_PODCAST_EPISODER.findIndex(ep => ep.episodeId === a.episodeId || ep.id === a.id || ep.title === a.title);
              const idxB = INITIAL_PODCAST_EPISODER.findIndex(ep => ep.episodeId === b.episodeId || ep.id === b.id || ep.title === b.title);
              if (idxA !== -1 && idxB !== -1) return idxA - idxB;
              if (idxA !== -1) return -1;
              if (idxB !== -1) return 1;
              const idNumA = parseInt(a.episodeId, 10) || 0;
              const idNumB = parseInt(b.episodeId, 10) || 0;
              return idNumB - idNumA;
            });
            setPodcastEpisoder(mapped);
          }
        }

        // Process artikler (Blog posts)
        if (artiklerRes.status === 'fulfilled' && artiklerRes.value.ok) {
          const json = await artiklerRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            const mapped = json.items.map((item) => {
              const slugDa = item.url_slug?.da || (typeof item.url_slug === 'string' ? item.url_slug : item.id);
              const slugEn = item.url_slug?.en || slugDa;
              const categoryTerm = item.terms?.emne?.[0] || 'ny-tids-lederskab';
              const categoryLabels = {
                'ny-tids-lederskab': { da: 'Ny Tids Lederskab', en: 'New Era Leadership' },
                'spirituelle-indsigter': { da: 'Spirituelle indsigter', en: 'Spiritual Insights' },
                'personlig-rejse': { da: 'Personlig rejse', en: 'Personal Journey' },
                'livsaendring': { da: 'Livsændring', en: 'Life Transformation' },
                'hjertets-intelligens': { da: 'Hjertets intelligens', en: 'Heart Intelligence' }
              };
              const catObj = categoryLabels[categoryTerm] || { da: 'Ny Tids Lederskab', en: 'New Era Leadership' };

              return {
                id: slugDa,
                slugDa,
                slugEn,
                title: item.titel?.da || (typeof item.titel === 'string' ? item.titel : ''),
                titleEn: item.titel?.en || item.titel?.da || '',
                date: item.dato ? new Date(item.dato).toLocaleDateString('da-DK', { day: 'numeric', month: 'long', year: 'numeric' }) : '',
                dateEn: item.dato ? new Date(item.dato).toLocaleDateString('en-US', { day: 'numeric', month: 'long', year: 'numeric' }) : '',
                category: catObj.da,
                categoryEn: catObj.en,
                image: item.billede?.[0] || '',
                excerpt: item.uddrag?.da || (typeof item.uddrag === 'string' ? item.uddrag : ''),
                excerptEn: item.uddrag?.en || item.uddrag?.da || '',
                htmlContentDa: item.indhold?.da || (typeof item.indhold === 'string' ? item.indhold : ''),
                htmlContentEn: item.indhold?.en || item.indhold?.da || ''
              };
            });
            setBlogPosts(mapped);
          }
        }

        // Process retreats
        if (retreatsRes.status === 'fulfilled' && retreatsRes.value.ok) {
          const json = await retreatsRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setRetreats(json.items);
          }
        }

        // Process forløb & workshops
        if (forloebRes.status === 'fulfilled' && forloebRes.value.ok) {
          const json = await forloebRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setCourses(json.items);
          }
        }

        // Process sessioner
        if (sessionerRes.status === 'fulfilled' && sessionerRes.value.ok) {
          const json = await sessionerRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setSessions(json.items);
          }
        }

        // Process virksomheder
        if (virksomhederRes.status === 'fulfilled' && virksomhederRes.value.ok) {
          const json = await virksomhederRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setVirksomheder(json.items);
          }
        }

        // Process om_mette
        if (omMetteRes.status === 'fulfilled' && omMetteRes.value.ok) {
          const json = await omMetteRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setOmMette(json.items[0]);
          }
        }

        // Process forside
        if (forsideRes.status === 'fulfilled' && forsideRes.value.ok) {
          const json = await forsideRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setForside(json.items[0]);
          }
        }

        // Process workshop_frisaet_dig
        if (workshopFrisaetDigRes.status === 'fulfilled' && workshopFrisaetDigRes.value.ok) {
          const json = await workshopFrisaetDigRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setWorkshopFrisaetDig(json.items[0]);
          }
        }

        // Process kvinde_kend_din_power
        if (kvindeKendDinPowerRes.status === 'fulfilled' && kvindeKendDinPowerRes.value.ok) {
          const json = await kvindeKendDinPowerRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setKvindeKendDinPower(json.items[0]);
          }
        }

        // Process retreat_montserrat
        if (retreatMontserratRes.status === 'fulfilled' && retreatMontserratRes.value.ok) {
          const json = await retreatMontserratRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setRetreatMontserrat(json.items[0]);
          }
        }

        // Process retreat_costa_del_sol
        if (retreatCostaDelSolRes.status === 'fulfilled' && retreatCostaDelSolRes.value.ok) {
          const json = await retreatCostaDelSolRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setRetreatCostaDelSol(json.items[0]);
          }
        }

        // Process retreat_thailand
        if (retreatThailandRes.status === 'fulfilled' && retreatThailandRes.value.ok) {
          const json = await retreatThailandRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setRetreatThailand(json.items[0]);
          }
        }

        // Process virksomhedspraktik
        if (virksomhedspraktikRes.status === 'fulfilled' && virksomhedspraktikRes.value.ok) {
          const json = await virksomhedspraktikRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setVirksomhedspraktik(json.items[0]);
          }
        }

        // Process frisaet_dig
        if (frisaetDigRes.status === 'fulfilled' && frisaetDigRes.value.ok) {
          const json = await frisaetDigRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setFrisaetDig(json.items[0]);
          }
        }

        // Process frisaet_dig_moduler
        if (frisaetDigModulerRes.status === 'fulfilled' && frisaetDigModulerRes.value.ok) {
          const json = await frisaetDigModulerRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            const sorted = [...json.items].sort((a, b) => (Number(a.nummer) || 0) - (Number(b.nummer) || 0));
            setFrisaetDigModuler(sorted);
          }
        }

        // Process gratis_workshop
        if (gratisWorkshopRes.status === 'fulfilled' && gratisWorkshopRes.value.ok) {
          const json = await gratisWorkshopRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setGratisWorkshop(json.items[0]);
          }
        }

        // Process gratis_meditationer
        if (gratisMeditationerRes.status === 'fulfilled' && gratisMeditationerRes.value.ok) {
          const json = await gratisMeditationerRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setGratisMeditationer(json.items[0]);
          }
        }

        // Process meditationer
        if (meditationerRes.status === 'fulfilled' && meditationerRes.value.ok) {
          const json = await meditationerRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            const sorted = [...json.items].sort((a, b) => (Number(a.nummer) || 0) - (Number(b.nummer) || 0));
            setMeditationer(sorted);
          }
        }

        // Process navigation
        if (navigationRes.status === 'fulfilled' && navigationRes.value.ok) {
          const json = await navigationRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setNavigation(json.items);
          }
        }

        // Process foredrag
        if (foredragRes.status === 'fulfilled' && foredragRes.value.ok) {
          const json = await foredragRes.value.json();
          if (json?.items && Array.isArray(json.items) && json.items.length > 0) {
            setForedrag(json.items[0]);
          }
        }

      } catch (err) {
        console.warn('CMS data fetch notice:', err);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };

    fetchAllCmsData();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <CmsContext.Provider
      value={{
        testimonials,
        podcasts,
        podcastEpisoder,
        fyraftenVideos,
        blogPosts,
        retreats,
        courses,
        sessions,
        virksomheder,
        omMette,
        forside,
        workshopFrisaetDig,
        kvindeKendDinPower,
        retreatMontserrat,
        retreatCostaDelSol,
        retreatThailand,
        virksomhedspraktik,
        frisaetDig,
        frisaetDigModuler,
        gratisWorkshop,
        gratisMeditationer,
        meditationer,
        navigation,
        foredrag,
        isLoading
      }}
    >
      {children}
    </CmsContext.Provider>
  );
};

export const useCms = () => {
  const context = useContext(CmsContext);
  if (!context) {
    return {
      testimonials: INITIAL_TESTIMONIALS,
      podcasts: INITIAL_PODCASTS,
      podcastEpisoder: INITIAL_PODCAST_EPISODER,
      fyraftenVideos: INITIAL_FYRAFTEN_VIDEOS,
      blogPosts: INITIAL_BLOG_POSTS,
      retreats: [],
      courses: [],
      sessions: [],
      virksomheder: [],
      omMette: null,
      forside: null,
      workshopFrisaetDig: null,
      kvindeKendDinPower: null,
      retreatMontserrat: null,
      retreatCostaDelSol: null,
      retreatThailand: null,
      virksomhedspraktik: null,
      frisaetDig: null,
      frisaetDigModuler: [],
      gratisWorkshop: null,
      gratisMeditationer: null,
      meditationer: [],
      navigation: [],
      foredrag: null,
      isLoading: false
    };
  }
  return context;
};
